<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Documentación del proceso queja</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <div class="col-md-12">
        <legend>
          <small>
            <p class="text-primary">Documentos del OEC</p>
          </small>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col" class="align-middle">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 10%"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inputs.complaint_document_oec">
              <td class="align-middle">
                {{
                  inputs.complaint_document_oec.path.split("/")[
                    inputs.complaint_document_oec.path.split("/").length - 1
                  ]
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs.complaint_document_oec.path)
                  "
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>

            <tr v-if="inputs.no_proceed_complaint_document">
              <td class="align-middle">
                {{
                  inputs.no_proceed_complaint_document.path.split("/")[
                    inputs.no_proceed_complaint_document.path.split("/").length - 1
                  ]
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs.no_proceed_complaint_document.path)
                  "
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12" v-if="inputs.attach_complaint_document_oec && inputs.attach_complaint_document_oec.length > 0">
        <legend>
          <small>
            <p class="text-primary">Documentos adicionales del OEC</p>
          </small>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col" class="align-middle">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 10%"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(value, key) in inputs.attach_complaint_document_oec"
              :key="key"
            >
              <td class="align-middle">
                {{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(inputs.attach_complaint_document_oec, key)
                    "
                  >
                    <app-icon name="file" />
                    
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12">
        <legend>
          <small
            ><p class="text-primary">
              Informe del técnico y recomendaciones
            </p></small
          >
        </legend>

        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col" class="align-middle">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 10%"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inputs.review_complaint_document">
              <td class="align-middle">
                {{
                  inputs.review_complaint_document.path.split("/")[
                    inputs.review_complaint_document.path.split("/").length - 1
                  ]
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs.review_complaint_document.path)
                  "
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>

            <tr v-if="inputs.meeting_complaint_document">
              <td class="align-middle">
                {{
                  inputs.meeting_complaint_document.path.split("/")[
                    inputs.meeting_complaint_document.path.split("/").length - 1
                  ]
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs.meeting_complaint_document.path)
                  "
                >
                  <app-icon name="file" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        
      </div>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";
import { axiosGet } from "@/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin, ModalMixin],
  components: { quillEditor },
  props: {
    tableId: String,
    modalTitle: String,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      inputs: {},
      reasonList: [],
      modalId: "modal-add-edit",

      accreditationActivityLists: [{ id: "", value: this.$t("select_option") }],
    };
  },

  created() {
    if (this.selectedUrlDoc) {
      this.preloader = true;
    } else {
      this.loaded = true;
    }
  },
  methods: {
    openTab(path) {
      window.open(path, "_blank").focus();
    },
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = {
        ...response.data,
        accreditation_area_id:
          response.data.accreditation_activity.accreditation_area_id,
      };
      this.onChangeAccreditationArea();
      this.preloader = false;
      this.loaded = true;
    },

    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.accreditation_area_id;
        }),
      ];
    },
    dataReason() {
      let reasonListUrl = `complaints/register/reasonComplaintsList/${1}`;
      axiosGet(reasonListUrl).then((response) => {
        this.reasonList = response.data;
      });
    },
  },
};
</script>
<style>
.color-req {
  color: red;
}

.space {
  margin-top: 100px;
}
</style>
